import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { MoneyAccountFormSchemaValues } from 'src/features/moneyAccounts/utils/formSchema';
import { MoneyAccount } from 'src/features/moneyAccounts/utils/types';

const RESOURCE = '/tenants/money-account/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: MoneyAccountFormSchemaValues): Promise<MoneyAccount> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateMoneyAccount };
